//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

interface Props {
  className?: string;
  children?: React.ReactNode;
}

/**
 * The GapGrid organism renders its children as a single row
 * This organism counts the number of children it has, and then displays
 * them in a grid layout with a single row and that many columns with the
 * appropriate spacing between each column.
 *
 * This organism should be used with children components that are meant to
 * fill all available space
 */
export const GapGrid = ({ children, className }: Props) => {
  return <Container className={className}>{children}</Container>;
};

const Container = styled.div(
  ({ children, theme }) => `
  display: grid;
  grid-template-columns: repeat(${React.Children.count(children)}, 1fr);
  grid-gap: ${theme.spacings[3]};
  margin-bottom: ${theme.spacings[3]};
`,
);

export default GapGrid;
